export default "__VITE_ASSET__C1fpaT1W__"